import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { withDefaults } from 'vue';

interface IProps {
  text: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomTooltip',
  props: {
    text: null
  },
  setup(__props: any) {

const props = __props as { text: string };



return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createBlock(_component_v_tooltip, {
    text: props.text,
    location: "top"
  }, {
    activator: _withCtx(({ props }) => [
      _createElementVNode("span", _normalizeProps(_guardReactiveProps(props)), [
        _renderSlot(_ctx.$slots, "default")
      ], 16)
    ]),
    _: 3
  }, 8, ["text"]))
}
}

})